<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="app应用商店" prop="appStore"></el-table-column>
        <el-table-column label="APP系统" prop="appSystem" align="center"></el-table-column>
        <el-table-column label="版本号" prop="appVersionCode" align="center"></el-table-column>
        <el-table-column label="功能" prop="funData" align="center"></el-table-column>
        <el-table-column label="创建时间" prop="createdTime" align="center" width="160"></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="120px">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row,1)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <notice-add ref="noticeAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
import noticeAdd from './add'
import onlineEnvironmentSwitchApi from '@/api/system/onlineEnvironmentSwitch'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
    noticeAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 重置
     */
    handleFilter() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 获取列表数据
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return onlineEnvironmentSwitchApi.fetchList(this.query)
        .then(res => {
          this.list = res.data.list
          this.total = res.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => appVersionApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({
            pageNo: 1
          })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => appVersionApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({
            pageNo: 1
          })
        })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.noticeAdd.handleCreate()
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.noticeAdd.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.noticeAdd.handleUpdate(row)
    }
  }
}
</script>
